import { render, staticRenderFns } from "./InvoiceCreateTemplate.vue?vue&type=template&id=56641e52&"
import script from "./InvoiceCreateTemplate.vue?vue&type=script&lang=js&"
export * from "./InvoiceCreateTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56641e52')) {
      api.createRecord('56641e52', component.options)
    } else {
      api.reload('56641e52', component.options)
    }
    module.hot.accept("./InvoiceCreateTemplate.vue?vue&type=template&id=56641e52&", function () {
      api.rerender('56641e52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/creationPages/InvoiceCreateTemplate.vue"
export default component.exports